"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountProvider = AccountProvider;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const redux_injectors_1 = require("../../utils/@reduxjs/redux-injectors");
const slice_1 = require("./slice");
const saga_1 = require("./saga");
const slice_2 = require("./slice");
function AccountProvider({ children }) {
    (0, redux_injectors_1.useInjectReducer)({ key: slice_2.sliceKey, reducer: slice_2.reducer });
    (0, redux_injectors_1.useInjectSaga)({ key: slice_2.sliceKey, saga: saga_1.accountProviderSaga });
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(() => {
        dispatch(slice_1.accountProviderActions.getUser({}));
    }, [dispatch]);
    return children;
}
//# sourceMappingURL=AccountProvider.js.map